import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '.';
import { fetchGetForm } from '../../node/repositories/lead-realtor-form/v4/get-form';
import { IApplicationContext } from '../types/ICustomContextParams';
import { TFormStoreData } from '../types/form';

export type TLocationApiEndpoints = keyof typeof formDataApi.endpoints;
export let formDataApi: ReturnType<typeof createFormDataApi>;

export const createFormDataApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'formDataApi',
    baseQuery: createBaseQuery(ctx),

    endpoints: builder => ({
      getForm: builder.query<TFormStoreData, void>({
        query: () => ({
          fetchFunction: fetchGetForm,
          loggerInfo: {
            description: 'Получение схемы формы',
            degradation: 'Критическая ошибка',
          },
        }),
      }),
    }),
  });

  formDataApi = newApi;

  return newApi;
};
